module.exports = __webpack_public_path__ + "static/media/check-signed.e1655bb1.svg";